import { ErrDialogComponent } from './../views/features/err-dialog/err-dialog.component';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '../_services/authentication.service';
import { DialogService } from 'primeng/dynamicdialog';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(
    private authenticationService: AuthenticationService,
    public dialogService: DialogService
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(catchError(err => {

      switch (err.status) {

        case 0:
          // 網路不穩定
          console.log('網路不穩定', err)
          this.openErrDialog('網路不穩定，請確認網路連線')
          break;

        case 401:
          // auto logout if 401 response returned from api
          this.authenticationService.logout();
          break;

        case 403:
          // 無操作權限
          console.log('無操作權限', err)
          this.openErrDialog('無操作權限，請洽相關人員')
          break;

        case 404:
          // 路徑錯誤/資料不齊全
          console.log('路徑錯誤/資料不齊全', err)
          this.openErrDialog(`路徑錯誤/資料不齊全，請洽相關人員`)
          break;

        case 408:
          // Request Timeout
          console.log('Request Timeout', err)
          this.openErrDialog('請求超時，請稍後再試')
          break;

        case 500: case 502:
          // 伺服器錯誤
          console.log('伺服器錯誤', err)
          this.openErrDialog(`伺服器錯誤，請洽相關人員`)
          break;

        default:
          // 不明錯誤
          console.log('不明錯誤', err)
          this.openErrDialog(`錯誤代碼：${err.status}（${err.statusText}），請洽相關人員`)
          break;
      }
      console.log(err)

      const error = err.detailed;
      return throwError(error);
    })
    );
  }

  openErrDialog(status: string) {
    const ref = this.dialogService.open(ErrDialogComponent, {
      data: {
        message: status
      },
      header: 'Error',
      width: '350px'
    });
  }
}
